import React from 'react';
import Sortable from 'library/structures/sortable';
import styled from 'styled-components';
import { string } from 'prop-types';

const SortableHandle = styled.span`
  cursor: pointer;
  ${props => props.sortableHandleStyle}
`;

class SortableContainer extends Sortable {
  constructor(...params) {
    super(...params);
  }

  renderControls = (name, i, disabled) => (
    !disabled
      ? (
        <SortableHandle
          className="pairin-admin-segments-module-handle"
          sortableHandleStyle={this.props.sortableHandleStyle}
          onMouseDown={this._startDrag.bind(this, i)}>
          =
        </SortableHandle>
      )
      : null
  )

  mapChildren = (child, i) => {
    const { editing, visible, childrenClassName, ...props } = child.props;
    if (child.key === 'placeholder') {
      return React.cloneElement(child, {...props, ref: this.placeholderRef});
    }

    const className = [
      childrenClassName ? childrenClassName : 'pairin-admin-segments-module',
      child.props.disabled ? 'disabled' : ''
    ].filter(c=>c).join(' ');

    return (
      <div data-index={i} data-sortable={!child.props.disabled} key={child.key} className={className} style={{position: 'relative'}}>
        { React.cloneElement(child, props) }
        { this.renderControls(child.type.name, i, child.props.disabled) }
      </div>
    );
  }


  render() {
    const { component:Component='div', children, propClassName, ...props } = this.props;

    const ComputedChildren = (this.state.dragging ? this.state.children : React.Children.toArray(children)).filter(({ key })=>key!=='placeholder');


    if (this.state.placeholder) {
      // ComputedChildren.splice(this.state.currentDragIndex, 0, React.cloneElement(this.state.placeholder, {ref: 'placeholder', ...this.state.placeholder.props}));
      ComputedChildren.splice(this.state.currentDragIndex, 0, this.state.placeholder);
    }

    const className = [
      propClassName,
      this.state.dragging ? 'dragging' : null
    ].filter(c=>c).join(' ');

    return (
      <Component ref={this.parentRef} className={className} {...props}>
        { ComputedChildren.map(this.mapChildren) }
      </Component>
    );
  }
}

SortableContainer.propsTypes = {
  childrenClassName: string
};

export default SortableContainer;
